import { QueryKey } from 'react-query';
import { WaitingListSlot } from '@water-web/types';

import { EndpointQuery } from '../../request';
import { queryKeys } from './queryKeys';

export interface WaitingListTimeSlotsPayload {
  id: string;
  attemptId: string;
}

export class WaitingListTimeSlotsQuery extends EndpointQuery<WaitingListSlot, WaitingListTimeSlotsPayload> {
  constructor(baseUrl: string) {
    super();
    this.baseUrl = baseUrl;
  }

  getKey(payload: WaitingListTimeSlotsPayload): QueryKey {
    return queryKeys.timeSlot(payload);
  }

  request(payload: WaitingListTimeSlotsPayload, signal?: AbortSignal): Promise<WaitingListSlot> {
    return this.http.get(`/v1/customer/waiting-list-slot-times/${payload.id}/${payload.attemptId}`, {
      headers: this.buildHeaders(),
      signal,
      resourceUrl: '/customer/waiting-list-slot-times/:waitingListId/:attemptId',
    });
  }
}
